import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ApNotificationService,
  ApSnackBarService,
  ApUndoableOperationService,
} from 'webcommon/core-ui';
import { IColumnPk } from 'webcommon/shared';
import { DeleteFindControlItemOperation, FindControlDeleteCheckpoint } from './DeleteFindControlItemOperation';
import { ApFindControlService } from '../ap-findcontrol.service';
import { FcMergeItemModalService } from './fc-merge-item-modal.service';

@Injectable({
  providedIn: 'root',
})
export class ApFindControlDeleteService {
  constructor(
    private apNotificationService: ApNotificationService,
    private apFindControlService: ApFindControlService,
    private apSnackBarService: ApSnackBarService,
    private apUndoableOperationService: ApUndoableOperationService,
    private fcMergeItemModalService: FcMergeItemModalService,
  ) {
  }

  deleteItem(
    undoComponentId: number,
    findControlBehaviorId: string,
    findControlBehaviorName: string,
    primaryKeyColumnName: string,
    dataItem: IColumnPk): Observable<FindControlDeleteCheckpoint> {
      const operation = new DeleteFindControlItemOperation(
        this.apNotificationService,
        this.apFindControlService,
        this.apSnackBarService,
        this.apUndoableOperationService,
        undoComponentId,
        findControlBehaviorId,
        findControlBehaviorName,
        primaryKeyColumnName,
        dataItem,
        this.fcMergeItemModalService,
      );
      return operation.getObservable();
  }
}
